import axios from "axios";
import store from "@/store";
import { Message, MessageBox, Loading } from "element-ui";

let timeoutState = false; // 是否超时

const service = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 1000 * 120,
  headers: {
    "Content-Type": "application/json", // 默认请求头
    platformType: "operation",
    appCode: "operation"
  },
  transformRequest: [
    function (data) {
      if (typeof data === "undefined") {
        return JSON.stringify({});
      } else {
        return JSON.stringify(data);
      }
    }
  ]
});

service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    if (response.data != "" && typeof response.data.code === "undefined") {
      // 判断数据流
      return response;
    } else if (response.data.code === 0) {
      return response.data;
    } else if (response.data.code == -1 || response.data.code == 12) {
      store.dispatch("clearLoginUser"); // 清空本地登录信息
      // 登录失效
      if (!timeoutState) {
        timeoutState = true;
        MessageBox.confirm("登录状态超时，请重新登录！", "提示", {
          showClose: false,
          showCancelButton: false,
          closeOnClickModal: false,
          confirmButtonText: "去登录",
          type: "warning"
        })
          .then(() => {
            if (process.env.NODE_ENV === "development") {
              top.location.href = "/";
            } else {
              // saas云端
              if (process.env.PROJECT_ENV === "saas") {
                top.location.href = "/home/";
              } else {
                // front前置
                top.location.href = "/";
              }
            }
          })
          .catch(() => {
            timeoutState = false;
          });
      }
      return Promise.reject(response.data);
    } else {
      if (typeof response.config.headers.hideErrorMessage == "undefined") {
        Message({
          message: response.data.message || response.data.msg,
          type: "error",
          duration: 5 * 1000
        });
      }
      return Promise.reject(response.data);
    }
  },
  (error) => {
    Message({
      message: error.message || error.msg,
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/service.js